import { z } from "zod";

const requestSchema = z.object({
  id: z.number(),
  state: z.string(),
  type: z.string(),
  pickup_and_delivery_date: z.string(),
  in_out_storage: z.string(),
  updated_at: z.string(),
  relation: z.object({
    id: z.string(),
    name: z.string(),
  }),
});

export const tireSetSchema = z.object({
  id: z.number(),
  type: z.string(),
  sleep_set: z.boolean(),
  in_hotel: z.boolean(),
  car: z.object({
    id: z.string(),
    licence: z.string(),
    label: z.string(),
    freestock_tire: z.boolean(),
    relation: z.object({
      id: z.string(),
      name: z.string(),
    }),
  }),
  position: z.object({
    id: z.number(),
    position: z.string(),
    label: z.string(),
  }),
  relation_id: z.string(),
  storedLatestRequest: requestSchema,
  latestCompletedPickupRequest: requestSchema,
  latestCompletedDeliverRequest: requestSchema,
});
